import {
  DEFAULT_CATEGORIES,
  DEFAULT_VARIETALS,
  updateFacetDefaults,
  updateVarietalFacetDefaults,
} from '#wa/utils/filters/categories'
import { urlToFilters } from '#wa/utils/filters/filters'
import {
  condenseRegionsToAttribute,
  flattenRegions,
  getChildSlugs,
} from '#wa/utils/filters/regionSlugs'
import _ from 'lodash'

const DEFAULT_HEADER = {
  accounts_dropdown: false,
  items: {
    'All Wines': {
      link: '/store/',
    },
    Varietals: {
      link: null,
      active: false,
      submenu: {
        Reds: {
          link: '/store/red-wine/',
          active: false,
          submenu: {
            'Cabernet Sauvignon': {
              link: '/store/varietals/cabernet-sauvignon/',
            },
            'Pinot Noir': {
              link: '/store/varietals/pinot-noir/',
            },
            Zinfandel: {
              link: '/store/varietals/zinfandel/',
            },
            Syrah: {
              link: '/store/varietals/syrah/',
            },
            Merlot: {
              link: '/store/varietals/merlot/',
            },
            Sangiovese: {
              link: '/store/varietals/sangiovese/',
            },
            Nebbiolo: {
              link: '/store/varietals/nebbiolo/',
            },
            'Red Blends': {
              link: '/store/varietals/red-blend/',
            },
          },
        },
        Whites: {
          link: '/store/white-wine/',
          active: false,
          submenu: {
            Chardonnay: {
              link: '/store/varietals/chardonnay/',
            },
            'Pinot Grigio': {
              link: '/store/varietals/pinot-grigio/',
            },
            Riesling: {
              link: '/store/varietals/riesling/',
            },
            'Sauvignon Blanc': {
              link: '/store/varietals/sauvignon-blanc/',
            },
          },
        },
        'Sparkling & Rose': {
          link: '/store/sparkling-rose/',
          submenu: {},
        },
        Sake: {
          link: '/store/sake/',
          submenu: {},
        },
        SweetFortified: {
          link: '/store/sweet-fortified/',
          submenu: {},
        },
        'Shop All Wines': {
          link: '/store/',
          submenu: {},
        },
      },
    },
    Regions: {
      link: null,
      active: false,
      submenu: {
        California: {
          link: '/store/regions/california/',
          active: false,
          submenu: {
            'Napa Valley': {
              link: '/store/regions/napa-valley/',
            },
            'Sonoma County': {
              link: '/store/regions/sonoma-county/',
            },
            'Central Coast': {
              link: '/store/regions/central-coast/',
            },
          },
        },
        Oregon: {
          link: '/store/regions/oregon/',
          submenu: {},
        },
        'All North America': {
          link: '/store/regions/north-america/',
          submenu: {},
        },
        France: {
          link: '/store/regions/france/',
          active: false,
          submenu: {
            Bordeaux: {
              link: '/store/regions/bordeaux/',
            },
            Burgundy: {
              link: '/store/regions/burgundy/',
            },
            Champagne: {
              link: '/store/regions/champagne/',
            },
            'Loire Valley': {
              link: '/store/regions/loire/',
            },
            Rhone: {
              link: '/store/regions/rhone/',
            },
          },
        },
        Italy: {
          link: '/store/regions/italy/',
          active: false,
          submenu: {
            Piedmont: {
              link: '/store/regions/piedmont/',
            },
            Tuscany: {
              link: '/store/regions/tuscany/',
            },
          },
        },
        Spain: {
          link: '/store/regions/spain/',
          submenu: {},
        },
        'All Europe': {
          link: '/store/regions/europe/',
          submenu: {},
        },
        'South America': {
          link: '/store/regions/south-america/',
          active: false,
          submenu: {
            Argentina: {
              link: '/store/regions/argentina/',
              submenu: {},
            },
          },
        },
        Australia: {
          link: '/store/regions/australia/',
          submenu: {},
        },
        'New Zealand': {
          link: '/store/regions/new-zealand/',
          submenu: {},
        },
        Japan: {
          link: '/store/regions/japan/',
          submenu: {},
        },
        'Shop All Wines': {
          link: '/store/',
          submenu: {},
        },
      },
    },
    'Food Pairings': {
      active: false,
      submenu: {
        'Red Meat': {
          link: '/store/food_pairings/red-meat/',
          submenu: {},
          slug: 'red-meat',
          image: '',
        },

        'White Meat': {
          link: '/store/food_pairings/white-meat/',
          submenu: {},
          slug: 'white-meat',
          image: '',
        },
        'Cured Meat': {
          link: '/store/food_pairings/cured-meat/',
          submenu: {},
          slug: 'cured-meat',
          image: '',
        },
        Fish: {
          link: '/store/food_pairings/fish/',
          submenu: {},
          slug: 'fish',
          image: '',
        },
        Shellfish: {
          link: '/store/food_pairings/shellfish/',
          submenu: {},
          slug: 'shellfish',
          image: '',
        },
        'Hard Cheese': {
          link: '/store/food_pairings/hard-cheese/',
          submenu: {},
          slug: 'hard-cheese',
          image: '',
        },
        'Soft Cheese': {
          link: '/store/food_pairings/soft-cheese/',
          submenu: {},
          slug: 'soft-cheese',
          image: '',
        },
        Vegetables: {
          link: '/store/food_pairings/vegetables/',
          submenu: {},
          slug: 'vegetables',
          image: '',
        },
        Spicy: {
          link: '/store/food_pairings/spicy/',
          submenu: {},
          slug: 'spicy',
          image: '',
        },
        Dessert: {
          link: '/store/food_pairings/sweets/',
          submenu: {},
          slug: 'sweets',
          image: '',
        },
      },
    },
    Collections: {
      active: false,
      submenu: {},
    },
    'My Account': {
      active: false,
      submenu: {},
    },
    Categories: {
      active: false,
      submenu: {},
    },
    LimitedTimeOffers: {
      link: '/store/is_offer/true/',
    },
    ShipImmediatelyOffers: {
      link: '/store/is_offer/false/',
    },
    Port: {
      link: '/store/sweet-fortified/',
    },
    WineSets: {
      link: '/store/wine-sets/',
    },
    NotifyMe: {
      link: '/store/notify-me/',
    },
    Personalized: {
      link: '/store/personalized/',
    },
  },
}

function processFacets(varietals, facetNames, rawFacets) {
  const facets = {
    categories: DEFAULT_CATEGORIES,
    varietals: DEFAULT_VARIETALS,
  }
  facets.price = rawFacets._filter_price.price.buckets
  facets.food_pairings = rawFacets._filter_food_pairings.food_pairings.buckets
  facets.vintage = rawFacets._filter_vintage.vintage.buckets
  facets.expert_reviewers =
    rawFacets._filter_expert_reviewers.expert_reviewers.buckets
  facets.occasions = rawFacets._filter_occasions.occasions.buckets
  if (rawFacets._filter_varietal_categories) {
    facets.varietal_categories =
      rawFacets._filter_varietal_categories.varietal_categories.buckets
  }
  facets.is_offer = rawFacets._filter_is_offer.is_offer.buckets
  facets.wineries = []

  updateFacetDefaults(
    'categories',
    facets,
    rawFacets._filter_categories.categories.buckets,
  )
  updateVarietalFacetDefaults(
    facets,
    rawFacets._filter_varietals.varietals.buckets,
    varietals,
  )

  // Add is_offer facet, if missing
  if (!facets.is_offer.some((f) => f.key === 1)) {
    facets.is_offer.push({ key: 1, key_as_string: 'true', doc_count: 0 })
  }

  let filters = []
  Object.keys(facets).forEach((facetCategory) => {
    let categoryFilters = facets[facetCategory].map((filter) => {
      filter.name = null
      if (!['price', 'is_offer', 'vintage'].includes(facetCategory)) {
        filter.name = facetNames[facetCategory][filter.key]
      } else if (facetCategory === 'is_offer') {
        if (filter.key === 0) {
          filter.name = 'Ships Immediately (The Store)'
        } else if (filter.key === 1) {
          filter.name = 'Limited Time Offer (Preorders)'
        }
      } else {
        filter.name = filter.key
      }
      filter.category = facetCategory
      filter.docCount = filter.doc_count

      // Delete redundant doc_count
      delete filter.doc_count

      return filter
    })
    /* Exclude filters which do not have a name, which would show up as blank
         checkboxes without a label in the UI.
         Occasions may be associated with a product, but if they are not present
         in metadata to indicate that they are homepage collections, do not expose
         them in filters */
    categoryFilters = categoryFilters.filter((item) => item.name)

    // Alphabetize occasions
    if (facetCategory === 'occasions') {
      categoryFilters.sort((a, b) => a.name.localeCompare(b.name))
    }
    // Alphabetize varietals
    if (facetCategory === 'varietals') {
      categoryFilters.sort((a, b) => a.name.localeCompare(b.name))
    }
    // Reverse alphabetize vintages (to essentially put them in reverse chronological order)
    if (facetCategory === 'vintage') {
      categoryFilters.sort((a, b) => b.name.localeCompare(a.name))
    }

    filters = filters.concat(categoryFilters)
  })

  return filters
}

function generateFilterMapping(searchFilters) {
  const mapping = {}
  searchFilters.forEach((f, i) => {
    if (!mapping[f.category]) mapping[f.category] = {}
    mapping[f.category][f.key] = i
  })
  return mapping
}

function processFacetNames(facetNames) {
  const filterSlugToName = { wineries: {}, searchable_varietal_categories: {} }
  Object.keys(facetNames).forEach((facetCategory) => {
    filterSlugToName[facetCategory] = {}
    facetNames[facetCategory].forEach((filter) => {
      filterSlugToName[facetCategory][filter.slug] = filter.name
      if (facetCategory === 'varietal_categories' && filter.include_in_search) {
        filterSlugToName.searchable_varietal_categories[filter.slug] =
          filter.name
      }
    })
  })
  return filterSlugToName
}

export const useMetadata = defineStore('metadata', () => {
  const requestFetch = useRequestFetch()
  const init = ref(false)
  const constance = ref({})
  const facetNames = ref({})
  const varietalObjs = ref({})
  const filters = ref([])
  const customerService = ref({})
  const redWine = ref({})
  const whiteWine = ref({})
  const categories = ref({})
  const food = ref([])
  const occasions = ref([])
  const gifting_menu_items = ref([])
  const varietals = ref([])
  const vintage = ref([])
  const expert_reviewers = ref([])
  const varietalCategories = ref({})
  const settingsVars = ref({})
  const tinycontent = ref({})
  const seo = ref({})
  const addressStateData = ref([])
  const stateNamesToCodes = ref({})
  const stateCodesToNames = ref({})
  const stateNamesToIds = ref({})
  const stateCodesToIds = ref({})
  const sortingOptions = ref([])
  const states = ref([])
  const podcast = ref({
    show_link: false,
  })
  const header = ref(DEFAULT_HEADER)
  // filters.js
  const searchFilters = ref([])
  const searchFiltersMapping = ref({})
  // regionsFilters.js
  const regions = ref({})
  const regionsIndex = ref([])
  const regionsFilters = ref({})
  const selectedRegions = ref([])
  const selectedRegionSlugs = computed(() => {
    return selectedRegions.value
  })
  const selectedRegionChips = computed(() => {
    return condenseRegionsToAttribute(
      regionsFilters.value,
      selectedRegions.value,
      'chipName',
    )
  })
  const regionsWithSelections = computed(() => {
    const setSelected = (region) => {
      const newRegion = {
        ...region,
        regions: undefined,
      }
      // Set children
      if (region.regions) {
        newRegion.regions = {}
        for (const r in region.regions) {
          newRegion.regions[r] = setSelected(region.regions[r])
        }
      }
      newRegion.checked =
        (newRegion.slugs &&
          newRegion.slugs.some((s) => selectedRegions.value.includes(s))) ||
        (newRegion.regions &&
          Object.values(newRegion.regions).some((s) => s.checked))
      return newRegion
    }

    return Object.entries(regions.value).reduce((filters, [key, filter]) => {
      filters[key] = setSelected(filter)
      return filters
    }, {})
  })

  function setRegions(payload) {
    regions.value = payload
    for (const region of Object.values(regions.value)) {
      if (region.regions) {
        region.regions.forEach((r) => (regionsFilters.value[r.slug] = r))
      }
      if (region.unspecifiedItems) {
        region.unspecifiedItems.forEach(
          (r) => (regionsFilters.value[r.slug] = r),
        )
      }
    }
    regionsIndex.value = flattenRegions({ regions: regionsFilters.value })
  }
  function selectRegion({ region }) {
    selectedRegions.value = Array.from(
      new Set(selectedRegions.value.concat(getChildSlugs(region))),
    ).filter((s) => s)
  }
  function deselectRegion({ region }) {
    const deselectSlugs = getChildSlugs(region)
    selectedRegions.value = selectedRegions.value.filter(
      (s) => !deselectSlugs.includes(s),
    )
  }
  function deselectAllRegions() {
    selectedRegions.value = []
  }
  function setSelectedRegionsFromUrl({ route }) {
    selectedRegions.value = urlToFilters({ route })
      .filter((f) => f.category === 'region_slug')
      .map((f) => f.key)
  }

  function setFood(payload) {
    food.value = payload
    const foodIcon = {}
    payload.forEach((item) => {
      foodIcon[item.slug] = item.icon
    })
    const subMenu = header.value.items['Food Pairings'].submenu
    header.value.items['Food Pairings'].submenu = Object.assign(
      {},
      subMenu,
      Object.keys(subMenu).forEach((key) => {
        if (subMenu[key].slug) {
          subMenu[key].image = foodIcon[subMenu[key].slug]
        }
      }),
    )
  }
  function seoForPath() {
    // Return seo data for this `path`. Handle presence or lack of trailing slash
    // because nuxt is not configured to use trailing slashes everywhere but
    // django was, and seo data is defined as such.
    // Unpack the seoData object array - it's unclear what multiple seo data
    // associations would mean to a single route
    return (path) => {
      if (Object.keys(seo.value).includes(path)) {
        return seo.value[path]
      } else if (Object.keys(seo.value).includes(path + '/')) {
        return seo.value[path + '/']
      }
      return null
    }
  }
  function setFacetNames(payload) {
    const tempNames = _.cloneDeep(facetNames.value)
    Object.keys(payload).forEach((key) => (tempNames[key] = payload[key]))
    facetNames.value = tempNames
  }
  function setTinycontent(payload) {
    const dict = {}
    payload.forEach((item) => {
      dict[item.key] = item.value
    })
    tinycontent.value = dict
  }
  function setOccasions(payload) {
    occasions.value = payload
    header.value.items.Collections.submenu = payload
  }
  function setVarietalCategories(payload) {
    varietalCategories.value = payload
    header.value.items.Categories.submenu = payload
  }

  function searchFiltersByCategory(category) {
    if (searchFiltersMapping.value[category]) {
      return Object.values(searchFiltersMapping.value[category]).map(
        (index) => {
          return searchFilters.value[index]
        },
      )
    }
    return []
  }
  function searchFilterByCategoryAndKey(category, key) {
    if (key === 'true') key = '1'
    else if (key === 'false') key = '0'
    if (
      searchFiltersMapping.value[category] &&
      searchFiltersMapping.value[category][key]
    ) {
      return searchFilters.value[searchFiltersMapping.value[category][key]]
    }
    return undefined
  }
  function pushFilters(filters) {
    filters.forEach((filter) => {
      if (!searchFiltersMapping.value[filter.category])
        searchFiltersMapping.value[filter.category] = {}
      searchFiltersMapping.value[filter.category][filter.key] =
        searchFilters.value.push(filter) - 1
    })
  }

  async function loadAddressStateData() {
    const resp = await requestFetch('/api/address/state/')
    addressStateData.value = resp.results
    stateNamesToCodes.value = _.chain(addressStateData.value)
      .mapKeys((state) => state.name)
      .mapValues((state) => state.usps_code)
      .value()
    stateCodesToNames.value = _.chain(addressStateData.value)
      .mapKeys((state) => state.usps_code)
      .mapValues((state) => state.name)
      .value()
    stateNamesToIds.value = _.chain(addressStateData.value)
      .mapKeys((state) => state.name)
      .mapValues((state) => state.id)
      .value()
    stateCodesToIds.value = _.chain(addressStateData.value)
      .mapKeys((state) => state.usps_code)
      .mapValues((state) => state.id)
      .value()
  }

  async function loadSearchFilters() {
    const resp = await requestFetch('/api/catalog/facets/')
    searchFilters.value = processFacets(
      varietals.value,
      facetNames.value,
      resp.facets,
    )
    searchFiltersMapping.value = generateFilterMapping(searchFilters.value)
  }

  async function loadConstance() {
    const resp = await requestFetch('/api/metadata/constance/')
    const config = {}
    resp.config.forEach((item) => {
      config[item.key] = item.value
    })
    constance.value = config
    customerService.value = {
      numberDisplay: config.CUSTOMER_SERVICE_PHONE_NUMBER,
      number: '1' + config.CUSTOMER_SERVICE_PHONE_NUMBER.replace(/[^0-9]/g, ''),
      email: config.CUSTOMER_SERVICE_EMAIL_ADDRESS,
      clubEmail: config.CUSTOMER_SERVICE_CLUB_EMAIL_ADDRESS,
      hoursLong: config.CUSTOMER_SERVICE_HOURS_LONG,
      hoursShort: config.CUSTOMER_SERVICE_HOURS_SHORT,
    }
  }

  async function loadMetadata() {
    // Fetches the metadata endpoint and also all constance settings
    const resp = await requestFetch('/api/metadata/')
    const cats = {}
    resp.categories.forEach((item) => {
      cats[item.slug] = item
    })
    categories.value = cats
    redWine.value = cats['red-wine']
    whiteWine.value = cats['white-wine']
    setFood(resp.food_pairings)
    setRegions(resp.regions)
    sortingOptions.value = resp.sorting_options
    varietals.value = resp.varietals
    vintage.value = resp.vintage
    expert_reviewers.value = resp.expert_reviewers
    setFacetNames(processFacetNames(resp.filter_names))
    settingsVars.value = resp.settings_data
    setTinycontent(resp.tinycontent)
    seo.value = resp.seo
    setVarietalCategories(resp.varietalCategories)
    podcast.value = resp.podcast
    setOccasions(resp.collections)
    gifting_menu_items.value = resp.gifting_menu_items
  }
  async function loadAll(force = false) {
    if (!init.value || force) {
      init.value = true
      await loadMetadata()
      await loadSearchFilters()
      await loadAddressStateData()
      await loadConstance()
    }
  }

  return {
    init,
    constance,
    facetNames,
    varietalObjs,
    filters,
    customerService,
    redWine,
    whiteWine,
    categories,
    food,
    occasions,
    gifting_menu_items,
    varietals,
    vintage,
    expert_reviewers,
    varietalCategories,
    settingsVars,
    tinycontent,
    seo,
    addressStateData,
    stateNamesToCodes,
    stateCodesToNames,
    stateNamesToIds,
    stateCodesToIds,
    sortingOptions,
    states,
    podcast,
    searchFilters,
    searchFiltersMapping,
    regions,
    regionsIndex,
    regionsFilters,
    regionsWithSelections,
    selectedRegions,
    selectedRegionSlugs,
    selectedRegionChips,
    pushFilters,
    selectRegion,
    deselectRegion,
    deselectAllRegions,
    setSelectedRegionsFromUrl,
    searchFiltersByCategory,
    searchFilterByCategoryAndKey,
    seoForPath,
    loadAddressStateData,
    loadConstance,
    loadMetadata,
    loadAll,
  }
})
